





















import { Vue, Component } from "vue-property-decorator";
import BorderedButton from "../components/BorderedButton.vue";

@Component({
  components: {
    BorderedButton
  }
})
export default class ComplianceHeader extends Vue {
  handleUserRejected() {
    this.$emit("user-acceptance", false);
  }
  handleUserAccepted() {
    this.$emit("user-acceptance", true);
  }
}
